"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredTradingPartnerGeneralBolInfo = void 0;
exports.RequiredTradingPartnerGeneralBolInfo = {
    AmazonIsaNumber: 'AMAZON_ISA_NUMBER',
    AmazonReferenceId: 'AMAZON_REFERENCE_ID',
    AmazonShipmentId: 'AMAZON_SHIPMENT_ID',
    CareOfCarrier: 'CARE_OF_CARRIER',
    CombinedShipmentWeight: 'COMBINED_SHIPMENT_WEIGHT',
    PoNumber: 'PO_NUMBER',
    Srn: 'SRN',
    VendorName: 'VENDOR_NAME',
    TotalCubicFeet: 'TOTAL_CUBIC_FEET',
    TotalPackageWeight: 'TOTAL_PACKAGE_WEIGHT'
};
//# sourceMappingURL=required-trading-partner-general-bol-info.js.map